module.exports = __webpack_public_path__ + "assets/img/news-6.900da34b.jpg";